skrilla.directive('queryMatches',function() {
    return {
        templateUrl: 'directives/matches/queryMatches.html',
        scope: {
            sport: "=",
            seasons: "="
        },
        controller: function($scope, searchService, cacheService, dateService, queryService, srefService){
            $scope.getDate = dateService.getUTC;
            $scope.childSelect = {tag: ""};
            $scope.tags = cacheService.getObject("productFeeTags")
            $scope.afterDate = new Date();
            $scope.afterDate.setHours(0, 0, 0, 0);
            $scope.beforeDate = new Date($scope.afterDate);
            $scope.beforeDate.setHours($scope.beforeDate.getHours() + 24);

            $scope.seasons = cacheService.getObjectOrElse($scope.sport + "Seasons", []);

            $scope.reset = function(){
                $scope.query={sport: $scope.sport};
            }
            $scope.reset();

            if($scope.tags === undefined || $scope.tags === null){
                searchService.get("betting/events/productFeeTagTypes").then(function(response){
                    var subs = [];
                    $scope.tags = response.data;
                    $scope.parentToChildren = response.data;
                    $scope.tags.forEach(function(tag){
                        subs = subs.concat(tag.second);
                    });
                    $scope.tags = $scope.tags.filter(function(tag){
                        return !subs.includes(tag.first);
                    })
                    cacheService.registerObject("productFeeTags", response.data);
                });
            }

            $scope.search = function() {
                searchService.get("matches/" + queryService.getQueryString($scope.query)).then(function (response) {
                    $scope.seasons = response.data;
                    cacheService.registerObject($scope.sport + "Seasons", $scope.seasons);
                });
            }


            $scope.navigate = function(season, match){
                srefService.go($scope.sport + "MatchDetails", {id: match.id});
            }

            $scope.selectedTag = function(){
                if($scope.parentSelect.second.length > 0){
                    $scope.query.tag = $scope.childSelect.tag;
                }
                else {
                    $scope.query.tag = $scope.parentSelect.first;
                }
            }
        }
    };
});
